// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1-tDt","title":"FrontImage_title__2dPgX"};